<h1>Offers</h1>

<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Filters <button id='offerListClear' type="button" (click)="clearFilters()"
        class="btn btn-default pull-right">Clear all</button>
    </h3>
  </div>
  <div class="panel-body">
    <div class="table-nav-menu">
      <div class="table-nav-menu">
        <span class="pull-right" *ngIf="exportingExcel">
          <div style="width: 28px; height: 28px;" class="loading-spinner"></div>
        </span>
        <a id='offerListExport' *ngIf="!exportingExcel" class="pull-right" (click)="downloadReport()">
          <i style="float: right;" class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
        </a>
        <ch-live-search [items]="locations" [showClass]="1" (change)="locationChanged($event)"
          [value]="pageParams.locationId"></ch-live-search>
        <ch-select-picker [items]="offerTypes" (change)="typeChanged($event)"
          [value]="pageParams.type"></ch-select-picker>
        <ch-select-picker [items]="offerTags" (change)="tagChanged($event)" [value]="pageParams.tag"></ch-select-picker>
        <ch-select-picker [items]="expiryDateFilters" (change)="expiryChanged($event)"
          [value]="pageParams.expiry"></ch-select-picker>
        <ch-search-input (search)="search($event)" value="{{ pageParams.search }}"></ch-search-input>
      </div>
      <div>
        <ch-checkbox-group (selected)="dayChanged($event)" [values]="selectedDays"
          multiselect="true"></ch-checkbox-group>
      </div>

      <div *ngIf="0">
        <div class="ch-checkbox-group">
          <span class="ch-checkbox-item" *ngFor="let checkBox of checkboxValues; let ix = index">
            <input (change)="checkboxChange(ix)" [checked]="checkBox.checked" type="checkbox"
              class="form-check-input" />
            <span>{{ checkBox.value }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">
    <div>
      Offers
      <div class="btn-group btn-group-sm ml-2" role="group" aria-label="...">
        <button type="button" class="btn btn-default" (click)="statusChanged($event, 'DRAFT')"
          [class.active]="pageParams.status === 'DRAFT'">
          <i class="fa fa-pencil-square-o" title="Draft"></i>
        </button>
        <button type="button" class="btn btn-default" (click)="statusChanged($event, 'PUBLISHED')"
          [class.active]="pageParams.status === 'PUBLISHED'">
          <i class="fa fa-rocket" title="Published"></i>
        </button>
        <button type="button" class="btn btn-default" (click)="statusChanged($event, 'EXPIRED')"
          [class.active]="pageParams.status === 'EXPIRED'">
          <i class="fa fa-calendar-times-o" title="Expired"></i>
        </button>
      </div>
    </div>
    <button type="button" (click)="addNew()" class="btn btn-default">New</button>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th class="sortable">
              <span class="col-name">
                Place
                <ch-sortable [column]="'ESTABLISHMENT'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th></th>
            <th class="sortable">
              <span class="col-name">Offer
                <ch-sortable [column]="'HEADLINE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th>Type</th>
            <th class="sortable">
              <span class="col-name">Expiry Date
                <ch-sortable [column]="'END_DATE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name">
                Offer Type
                <ch-sortable [column]="'OFFER_TYPE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td>
              <div>{{ item.establishmentName }}</div>
            </td>
            <td>
              <span class="badge">{{ item.redemptionsCount }}</span>
            </td>
            <td>
              <div>{{ item.headline }}</div>
            </td>
            <td>
              <span *ngFor="let type of item.typeNames && item.typeNames.length > 0 ? item.typeNames : []"
                class="offer-type label label-success">{{ type }}</span>
            </td>
            <td>{{ item.endDate | dateFormat }}</td>
            <td>
              <span class="offer-type label label-warning">
                {{ offerTypeLabel(item.offerType) }}
              </span>
            </td>
            <td class="col-md-1">
              <span *ngIf="item.exporting"
                style="width: 26px; height: 26px; display: inline-block; vertical-align: middle;"
                class="loading-spinner"></span>
              <a class="btn btn-primary" [routerLink]="['/admin/offer/advertise']"
                [queryParams]="{ offerId: item.id, cardTitle: item.establishmentName }">PN</a>
              <a *ngIf="!item.exporting" class="btn btn-primary" (click)="exportOffer(item.id)">Report</a>
              <a class="btn btn-primary" [routerLink]="['/admin/offers/edit']"
                [queryParams]="{ editId: item.id }">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination-dropdown *ngIf="!loading" [totalItems]="totalItems" [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize" (pageChanged)="onPageChanged($event)"></ch-pagination-dropdown>
  </div>
</div>

<ch-offer-export-modal-dialog [show]="showExportDialog" (onExport)="onExport($event)" [data]="exportData"
  (onClose)="onCloseExportDialog()"></ch-offer-export-modal-dialog>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/offers-list/offers-list.component.html